import { Anchor, LogOut, Menu } from "lucide-react";
import { nav } from "@/data/seed";

export const Sidebar = ({ user, module, setModule, onLogout }) => <aside className="sidebar">
  <div className="brand-mark"><Anchor size={22} /><span>SIP-IKAN</span></div>
  <div className="side-label">RUANG KERJA</div>
  <nav>{nav.map(([id, label, Icon]) => <button className={module === id ? "active" : ""} onClick={() => setModule(id)} key={id} data-testid={`nav-${id}-button`}><Icon size={19} /><span>{label}</span>{module === id && <i />}</button>)}</nav>
  <div className="side-bottom">
    <div className="sync"><span className="sync-dot" /><div><strong>Tersinkronisasi</strong><small>Data lokal tersimpan</small></div></div>
    <div className="profile"><div className="avatar">{user === "Admin" ? "AD" : "PT"}</div><div><strong>{user}</strong><small>Operator SIP-IKAN</small></div><button className="icon-btn" onClick={onLogout} data-testid="logout-button"><LogOut size={17} /></button></div>
  </div>
</aside>;

export const Topbar = ({ module }) => <header className="topbar">
  <button className="mobile-menu icon-btn" data-testid="mobile-menu-button"><Menu size={21} /></button>
  <div><span className="breadcrumb">SIP-IKAN / <strong>{nav.find((x) => x[0] === module)?.[1]}</strong></span></div>
  <div className="top-actions"><span className="online"><i /> Mode lokal aktif</span><button className="icon-btn" data-testid="notification-button">♢</button></div>
</header>;
